// extracted by mini-css-extract-plugin
module.exports = {"text":"headlineSkins-mediumOnConfined-text-db3b41ff"};